import React, { ErrorInfo, ReactNode } from "react";

interface Props {
	children?: ReactNode;
}

interface State {
	hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
	static getDerivedStateFromError(error: Error) {
		console.log(error);
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}
	state: Readonly<State> = { hasError: false };

	componentDidCatch(error: Error, info: ErrorInfo) {
		console.log(error, info);
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return <h1>Something went wrong.</h1>;
		}

		return this.props.children;
	}
}
